module.exports = __webpack_public_path__ + "static/img/page_bg.716ccd95.png";